module.exports = __webpack_public_path__ + "img/Trazado 2282.1a19c4c5.svg";